var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransmission({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0786 47.5702H4.64791C2.58605 47.5702 1 46.0392 1 44.1254V5.23671C1 3.3229 2.58605 1.7153 4.64791 1.7153H42.0786C44.0612 1.63875 45.6472 3.39945 45.6472 5.31326V44.2019C45.6472 46.1157 44.0612 47.7233 42.0786 47.7233V47.5702Z",
    stroke: "#5A5A5A",
    strokeWidth: 2,
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5298 14.3463C15.7197 14.3463 17.4949 12.6327 17.4949 10.5189C17.4949 8.40502 15.7197 6.69141 13.5298 6.69141C11.3399 6.69141 9.5647 8.40502 9.5647 10.5189C9.5647 12.6327 11.3399 14.3463 13.5298 14.3463Z",
    stroke: "#5A5A5A",
    strokeWidth: 2,
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5298 24.6046H33.1967M13.5298 14.6529V40.2212V14.6529ZM23.4426 9.14111V40.2212V9.14111ZM33.1967 9.14111V24.6046V9.14111Z",
    stroke: "#5A5A5A",
    strokeWidth: 2,
    strokeMiterlimit: 22.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransmission);
export default __webpack_public_path__ + "static/media/transmission.04f26a6b2c23ec346294873ba2ae03b2.svg";
export { ForwardRef as ReactComponent };